import { Stack, Typography } from '@mui/material'

type Props = {
  title: string
  text: string
  className?: string
}

export const Header = ({ title, text, className = '' }: Props) => {
  return (
    <Stack className={`gap-3 ${className}`}>
      <Typography className="text-2xl font-bold text-zBlack200">
        {title}
      </Typography>
      <Typography className="text-3d font-medium text-zGrey400">
        {text}
      </Typography>
    </Stack>
  )
}
